import { get, padStart } from 'lodash'
import moment from 'moment'

type TTime = {
  hour: string
  minute: string
  second?: string
}

type TParsedTime = {
  hour: string | number
  minute: string | number
  second?: string | number
}

type TTimeValues = {
  [key: string]: string
}

export function parseTime(value: string): TParsedTime {
  let fixedValue = value
  if (!String(fixedValue).includes(':')) {
    fixedValue = '00:00'
  }
  const split = fixedValue.split(':')
  const hour = padStart(String(get(split, 0, 0)), 2, '0')
  const minute = padStart(String(get(split, 1, 0)), 2, '0')
  return {
    hour,
    minute,
  }
}

export function serializeTime({ hour, minute }: TTime): string {
  if (!hour || !minute) {
    return '00:00'
  }
  return `${hour}:${minute}`
}
export const parseTimeWithSeconds = (
  values: TTimeValues,
  key: string,
): string =>
  get(values, `${key}`)
    ? moment(get(values, `${key}`), 'HH:mm:ss').format('H:mm')
    : '00:00'

export const stringifyTimeWithSeconds = (
  values: TTimeValues,
  key: string,
): string =>
  get(values, `${key}`)
    ? moment(get(values, `${key}`), 'H:mm').format('HH:mm:ss')
    : '00:00:00'
